document.addEventListener("DOMContentLoaded", function () {

  // =========================
  // DESKTOP
  // =========================
if (window.matchMedia("(min-width: 769px)").matches) {

  (function () {

    const EMAIL_SELECTOR =
      "#email_01KNWECT8PFH99EG9K78Z0GWKN";

    const ACCEPT_BTN_SELECTOR =
      ".cc-allow.isense-cc-allow.isense-cc-submit-consent";

    const SETTINGS_BTN_SELECTOR =
      ".cc-settings.isense-cc-settings";

    const SETTINGS_CLOSE_BTN_SELECTOR =
      ".OfalJEOFjZ2pJSizWL40.W6EoPGVh_NFp7pIx7tbt.cc-btn-close-settings";

    const MOBILE_FIRST_FOCUS =
      "#usntA42Link";

    let stepIndex = -1;
    let started = false;
    let isPaused = false;

    function isFocusable(el) {
      if (!el) return false;

      const style = getComputedStyle(el);

      if (
        style.display === "none" ||
        style.visibility === "hidden"
      ) {
        return false;
      }

      if (el.disabled) return false;

      return true;
    }

    function focusSafe(getElFn) {
      const el = getElFn();
      if (!el) return false;

      requestAnimationFrame(() => el.focus());
      return true;
    }

    function getEl(selector) {

      let el = document.querySelector(selector);

      if (el) return el;

      const host = document.querySelector("csm-cookie-consent");

      if (host && host.shadowRoot) {
        return host.shadowRoot.querySelector(selector);
      }

      return null;
    }

    const consentSteps = [
      () => getEl(MOBILE_FIRST_FOCUS),
      () => getEl(".consent-focus-element-1"),
      () => getEl(".consent-focus-element-2"),
      () => getEl(".consent-focus-element-3"),
      () => getEl(".consent-focus-element-4"),
      () => getEl(".cc-link.isense-cc-link"),
      () => getEl(SETTINGS_BTN_SELECTOR),
      () => getEl(ACCEPT_BTN_SELECTOR)
    ];

    function resetFlow() {
      stepIndex = -1;
      started = false;
      isPaused = false;
    }

    function exitToEmail() {

      document.removeEventListener("keydown", handler);

      setTimeout(() => {

        const emailEl =
          document.querySelector(EMAIL_SELECTOR);

        if (emailEl && isFocusable(emailEl)) {
          requestAnimationFrame(() => emailEl.focus());
        }

      }, 100);
    }

    const handler = function (e) {

      if (e.key !== "Tab") return;

      const settingsCloseBtn =
        getEl(SETTINGS_CLOSE_BTN_SELECTOR);

      // SETTINGS OPEN → pause custom flow, allow browser tabbing
      if (settingsCloseBtn) {
        isPaused = true;
        resetFlow();
        return;
      }

      // SETTINGS CLOSED BUT WAS PREVIOUSLY OPEN → resume fresh flow
      if (isPaused) {
        resetFlow();
      }

      e.preventDefault();

      const wrapper =
        document.querySelector("#usntA42Toggle");

      if (wrapper) {
        wrapper.style.display = "block";
        wrapper.removeAttribute("inert");
        wrapper.setAttribute("aria-hidden", "false");
      }

      if (!started) {
        started = true;
        stepIndex = 0;
      } else {
        stepIndex++;
      }

      if (stepIndex >= consentSteps.length) {
        stepIndex = 0;
      }

      let success = false;

      while (stepIndex < consentSteps.length) {

        success = focusSafe(consentSteps[stepIndex]);

        if (success) break;

        stepIndex++;
      }

      if (!success) {
        exitToEmail();
      }
    };

    document.addEventListener("keydown", handler);

  })();

}
  // =========================
  // MOBILE
  // =========================
else {

    (function () {

      const MOBILE_FIRST_FOCUS = "#usntA42Link";
      const EMAIL_SELECTOR = "#email_01KNWECT8PFH99EG9K78Z0GWKN";

      let started = false;
      let shadowObserverStarted = false;
      let emailFocused = false;

      function getEl(selector) {
        return document.querySelector(selector);
      }

      function getShadowRoot() {
        const host = document.querySelector("csm-cookie-consent");
        return host && host.shadowRoot ? host.shadowRoot : null;
      }

      function focusEl(el) {
        if (!el) return false;
        el.setAttribute("tabindex", "0");
        requestAnimationFrame(() => el.focus());
        return true;
      }

      function isSectionOpen(detailsPanelId) {
        const sr = getShadowRoot();
        if (!sr) return false;
        const panel = sr.querySelector("#" + detailsPanelId);
        if (!panel) return false;
        return panel.offsetParent !== null && panel.offsetHeight > 0;
      }

      function applyTabindexToContainers() {
        const sr = getShadowRoot();
        if (!sr) return;

        const sections = [
          "csm-mobile-cookie-details-strict",
          "csm-mobile-cookie-details-analytics",
          "csm-mobile-cookie-details-marketing",
          "csm-mobile-cookie-details-functionality"
        ];

        sections.forEach(sectionId => {
          const panel = sr.querySelector("#" + sectionId);
          if (!panel) return;

          const btn = sr.querySelector('[aria-controls="' + sectionId + '"]');
          const isOpen = btn && btn.getAttribute("aria-expanded") === "true";
          const panelVisible = panel.offsetHeight > 0 && panel.offsetParent !== null;
          const shouldFocus = isOpen || panelVisible;

          panel.querySelectorAll(".dp3uB1wRqwBdlhyW4pE2").forEach(container => {
            container.setAttribute("tabindex", shouldFocus ? "0" : "-1");
          });
        });
      }

      function watchAccordionWrapper() {
        const sr = getShadowRoot();
        if (!sr) return;

        const wrapper = sr.querySelector(".QXk0jPmmCrKCcgxioPE0 > div");
        if (!wrapper || wrapper.dataset.resizeObserved) return;

        wrapper.dataset.resizeObserved = "true";

        const ro = new ResizeObserver(() => {
          applyTabindexToContainers();
        });

        ro.observe(wrapper);
      }

      function fireComposedClick(el) {
        const evt = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          composed: true,
          view: window
        });
        el.dispatchEvent(evt);
      }

      function addTabindexToElements() {
        const sr = getShadowRoot();
        if (!sr) return;

        sr.querySelectorAll("button").forEach(btn => {
          if (!btn.hasAttribute("tabindex")) {
            btn.setAttribute("tabindex", "0");
          }
        });

        sr.querySelectorAll(".u91s0IjSGbrgc12s7slb").forEach(btn => {
          if (btn.dataset.clickBound) return;
          btn.dataset.clickBound = "true";

          btn.addEventListener("click", () => {
            setTimeout(() => {
              applyTabindexToContainers();
            }, 350);
          });

          btn.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              fireComposedClick(btn);
              setTimeout(() => {
                applyTabindexToContainers();
              }, 350);
            }
          });
        });

        sr.querySelectorAll(".lvCv2UAf1MWZGlTXc5RQ").forEach(toggle => {
          if (!toggle.hasAttribute("tabindex")) {
            toggle.setAttribute("tabindex", "0");
            toggle.setAttribute("role", "switch");
          }

          if (toggle.dataset.keyActivateBound) return;
          toggle.dataset.keyActivateBound = "true";

          toggle.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              fireComposedClick(toggle);
            }
          });
        });

        applyTabindexToContainers();

        watchAccordionWrapper();
      }

      function focusEmailIfConsentRemoved() {
        if (emailFocused) return;

        const host = document.querySelector("csm-cookie-consent");
        if (host) return;

        const email = document.querySelector(EMAIL_SELECTOR);
        if (email) {
          emailFocused = true;
          email.setAttribute("tabindex", "0");
          requestAnimationFrame(() => email.focus());
        }
      }

      function handleShadowContent() {
        const sr = getShadowRoot();
        if (!sr) return;

        const desc = sr.querySelector("#cookieconsent-desc");
        if (desc && desc.getAttribute("tabindex") === "-1") {
          desc.removeAttribute("tabindex");
        }

        const readMoreBtn = sr.querySelector(".YD612mvFegUbOnGBlxxm");
        const secondaryBtn = sr.querySelector(".oO_HavlBq8ty3IwGKZr7");
        const lastFocusBtn = sr.querySelector(".eIBD7yH_JVc06n5JtIUb");

        const acceptBtn = sr.querySelector(
          'button[aria-label*="ACCEPT ALL NON-ESSENTIAL COOKIES"]'
        );

        const dropDownBtn = sr.querySelector(".u91s0IjSGbrgc12s7slb");

        function getNextFocusTarget() {
          const optOutBtn = [...sr.querySelectorAll("button[aria-label]")]
            .find(btn =>
              btn.getAttribute("aria-label")?.includes("OPT OUT OF ALL NON-ESSENTIAL COOKIES")
            );

          const aria = optOutBtn?.getAttribute("aria-label") || "";

          if (aria.includes("OPT OUT OF ALL NON-ESSENTIAL COOKIES")) {
            return acceptBtn;
          }

          return dropDownBtn;
        }

        function bindFocus(el, isLastFocus = false) {
          if (!el || el.dataset.focusBound) return;

          el.dataset.focusBound = "true";

          el.addEventListener("keydown", function (e) {
            if (e.key === "Tab" && !e.shiftKey) {
              e.preventDefault();

              requestAnimationFrame(() => {
                if (isLastFocus) {
                  const firstFocus = getEl(MOBILE_FIRST_FOCUS);
                  if (firstFocus) {
                    firstFocus.setAttribute("tabindex", "0");
                    firstFocus.focus();
                  }
                } else {
                  getNextFocusTarget()?.focus();
                }
              });
            }
          });
        }

        bindFocus(readMoreBtn);
        bindFocus(secondaryBtn);
        bindFocus(lastFocusBtn, true);

        addTabindexToElements();
      }

      function startShadowObserver() {
        if (shadowObserverStarted) return;
        shadowObserverStarted = true;

        const observer = new MutationObserver(() => {
          handleShadowContent();
          focusEmailIfConsentRemoved();
          addTabindexToElements();
        });

        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true
        });

        const sr = getShadowRoot();
        if (sr) {
          const shadowObserver = new MutationObserver(() => {
            applyTabindexToContainers();
          });

          shadowObserver.observe(sr, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["aria-expanded", "style", "class"]
          });
        }

        handleShadowContent();
      }

      const handler = function (e) {
        if (e.key !== "Tab") return;

        const btn = getEl(MOBILE_FIRST_FOCUS);
        if (!btn) return;

        if (!started) {
          e.preventDefault();
          started = true;

          const wrapper = document.querySelector("#usntA42Toggle");
          if (wrapper) {
            wrapper.style.display = "block";
            wrapper.removeAttribute("inert");
            wrapper.setAttribute("aria-hidden", "false");
          }

          focusEl(btn);

          addTabindexToElements();

          const waitShadow = setInterval(() => {
            const host = document.querySelector("csm-cookie-consent");
            if (host && host.shadowRoot) {
              clearInterval(waitShadow);
              startShadowObserver();
            }
          }, 100);

          return;
        }
      };

      document.addEventListener("keydown", handler);

      setInterval(() => {
        handleShadowContent();
        focusEmailIfConsentRemoved();
      }, 300);

      document.addEventListener("DOMContentLoaded", () => {
        handleShadowContent();
        focusEmailIfConsentRemoved();
        addTabindexToElements();
      });

    })();

  }
});